import _ from 'lodash';

export default function isNumeric(str) {
    return _.isFinite(_.toNumber(str)) && !_.isNaN(_.toNumber(str))
}
